import { createSlice } from "@reduxjs/toolkit";
import VwKurumMailGonderimAyarlariDTO from "src/models/Settings/Generals/VwKurumMailGonderimAyarlariDTO";
import MapReducerPayloads from "src/models/store/MapReducerPayloads";


interface IKurumMailGonderimAyarlari {
    open: boolean;
    activeRow: VwKurumMailGonderimAyarlariDTO;
    filtreKriterleri: VwKurumMailGonderimAyarlariDTO
    searchHandler: boolean
    data: VwKurumMailGonderimAyarlariDTO[]
}

export const KurumMailGonderimAyarlariSlice = createSlice<IKurumMailGonderimAyarlari, MapReducerPayloads<IKurumMailGonderimAyarlari, {
    setOpen: boolean;
    setActiveRow: VwKurumMailGonderimAyarlariDTO
    setFiltreKriterleri: VwKurumMailGonderimAyarlariDTO
    setSearchHandler: boolean
    setData: VwKurumMailGonderimAyarlariDTO[]
}>>({
    name: "KurumMailGonderimAyarlari",
    initialState: {
        open: false,
        activeRow: new VwKurumMailGonderimAyarlariDTO(),
        filtreKriterleri: new VwKurumMailGonderimAyarlariDTO(),
        searchHandler: false,
        data: []
    },
    reducers: {
        setOpen: (state, action) => {
            state.open = action.payload;
        },
        setActiveRow: (state, action) => {
            state.activeRow = action.payload;
        },
        setFiltreKriterleri: (state, action) => {
            state.filtreKriterleri = action.payload;
        },
        setSearchHandler: (state, action) => {
            state.searchHandler = action.payload;
        },
        setData: (state, action) => {
            state.data = action.payload;
        }
    }

});